// extracted by mini-css-extract-plugin
export default {"firstPlace":"OrdinalColors_firstPlace__pzVvS","secondPlace":"OrdinalColors_secondPlace__nFgWj","thirdPlace":"OrdinalColors_thirdPlace__fnqtN"};